<template>
  <div class="page-container">
    <div class="page-header">
      <el-form :inline="true" :model="searchItem" class="demo-form-inline">
        <el-form-item style="width: 120px">
          <el-select v-model="searchItem.selectValue" placeholder="">
            <el-option label="rid" value="rid"></el-option>
            <el-option label="uid" value="uid"></el-option>
            <el-option label="username" value="username"></el-option>
            <el-option label="unique_rid" value="unique_rid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input v-model="searchItem.content" placeholder="输入查询内容，用逗号分割" style="min-width: 500px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="queryActors">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="page-content">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="uid">
                <span>{{ props.row.uid }}</span>
                <el-button v-if="props.row.uid" style="margin-left: 20px;" type="primary" size="mini"
                  @click="copyUrl(props.row.uid)">copy
                  url</el-button>
              </el-form-item>
              <el-form-item label="rid">
                <span>{{ props.row.rid }}</span>
              </el-form-item>
              <el-form-item label="name">
                <span>{{ props.row.name }}</span>
              </el-form-item>
              <el-form-item label="gender">
                <span>{{ props.row.gender }}</span>
              </el-form-item>
              <el-form-item label="gold">
                <span>{{ props.row.gold }}</span>
              </el-form-item>
              <el-form-item label="ver">
                <span>{{ props.row.ver }}</span>
              </el-form-item>
              <el-form-item label="register_platform">
                <span>{{ props.row.register_platform }}</span>
              </el-form-item>
              <el-form-item label="channel">
                <span>{{ props.row.channel }}</span>
              </el-form-item>
              <el-form-item label="vip_level">
                <span>{{ props.row.vip_level }}</span>
              </el-form-item>
              <el-form-item label="is_accept_call">
                <span>{{ props.row.is_accept_call }}</span>
              </el-form-item>
              <el-form-item label="translate_lang">
                <span>{{ props.row.translate_lang }}</span>
              </el-form-item>
              <el-form-item label="valid_status">
                <span>{{ props.row.valid_status }}</span>
              </el-form-item>
              <el-form-item label="Email">
                <span>{{ props.row.email }}</span>
              </el-form-item>
              <el-form-item label="login_type">
                <span>{{ props.row.login_type }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column label="uid" prop="uid">
          <template slot-scope="scope">
            {{ scope.row.uid }}
            <el-button type="primary" size="mini" @click="copyUrl(scope.row.uid)" v-if="scope.row.uid">copy
              url</el-button>
          </template>
        </el-table-column>
        <el-table-column label="rid" prop="rid"> </el-table-column>
        <el-table-column label="name" prop="name"> </el-table-column>
        <el-table-column label="gender" prop="gender"> </el-table-column>
        <el-table-column label="gold" prop="gold"> </el-table-column>
        <el-table-column label="vip_level" prop="vip_level"> </el-table-column>
        <el-table-column label="register_platform" prop="register_platform">
        </el-table-column>
      </el-table>
      <input type="text" id="a1" style=" opacity:0;" v-model="value" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'UserPage',
  data() {
    return {
      searchItem: {
        selectValue: 'rid',
        content: ''
      },
      value: '',
      tableData: [{}]
    }
  },
  methods: {
    copyUrl(url) {
      let Url2 = document.getElementById('a1')
      let newUrl = '?uid=' + url.replace(/\s-\s/i, "&session=");
      Url2.value = newUrl
      Url2.select()
      document.execCommand("copy");
      this.$message.success('copy success');
    },
    queryActors() {
      this.$axios({
        type: 'GET',
        url: this.$store.getters.path.users_query_actors,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          selectValue: this.searchItem.selectValue,
          content: this.searchItem.content
        }
      })
        .then(res => {
          if (res.data.code === 0) {
            this.tableData = res.data.data
          } else if (res.data.code === 1001) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
            this.$router.push(this.$route.query.redirect || '/login')
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: '请求错误' + err,
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;
}

.page-header {
  margin-top: 10px;
  margin-bottom: 10px;
}

.page-content {
  margin-top: 10px;
  margin-bottom: 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
</style>
